/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Energy_LowInputs */

const en_us2_workout_after_energy_low = /** @type {(inputs: Workout_After_Energy_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low`)
};

const pt_br2_workout_after_energy_low = /** @type {(inputs: Workout_After_Energy_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouca`)
};

const es_419_workout_after_energy_low = /** @type {(inputs: Workout_After_Energy_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poca`)
};

const pt_pt2_workout_after_energy_low = /** @type {(inputs: Workout_After_Energy_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pouca`)
};

const fr_fr2_workout_after_energy_low = /** @type {(inputs: Workout_After_Energy_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faible`)
};

const de_de2_workout_after_energy_low = /** @type {(inputs: Workout_After_Energy_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrig`)
};

const it_it2_workout_after_energy_low = /** @type {(inputs: Workout_After_Energy_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poca`)
};

/**
* | output |
* | --- |
* | "Low" |
*
* @param {Workout_After_Energy_LowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_energy_low = /** @type {((inputs?: Workout_After_Energy_LowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Energy_LowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_energy_low(inputs)
	if (locale === "es-419") return es_419_workout_after_energy_low(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_energy_low(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_energy_low(inputs)
	if (locale === "de-DE") return de_de2_workout_after_energy_low(inputs)
	if (locale === "it-IT") return it_it2_workout_after_energy_low(inputs)
	return en_us2_workout_after_energy_low(inputs)
});
export { workout_after_energy_low as "workout-after.energy_low" }